import { useState, useEffect } from "react";
import { fbWatch } from "./useFirebase";

// Escuta em tempo real as coleções usadas pelo Dashboard e pelos
// resumos da Home mobile — centralizado aqui para não duplicar
// listeners em cada tela que precisa das mesmas métricas.
export function useDashboardData() {
  const [pedidos,     setPedidos]     = useState([]);
  const [filamentos,  setFilamentos]  = useState([]);
  const [impressoras, setImpressoras] = useState([]);
  const [materiais,   setMateriais]   = useState([]);
  const [produtos,    setProdutos]    = useState([]);
  const [falhas,      setFalhas]      = useState([]);
  const [fila,        setFila]        = useState([]);
  const [orcamentos,  setOrcamentos]  = useState([]);
  const [vendas,      setVendas]      = useState([]);
  const [loading,     setLoading]     = useState(true);

  useEffect(() => {
    const unsubs = [
      fbWatch("pedidos",     d => { setPedidos(d); setLoading(false); }),
      fbWatch("filamentos",  setFilamentos),
      fbWatch("impressoras", setImpressoras),
      fbWatch("materiais",   setMateriais),
      fbWatch("produtos",    setProdutos),
      fbWatch("falhas",      setFalhas),
      fbWatch("fila_impressao", setFila),
      fbWatch("orcamentos",  setOrcamentos),
      fbWatch("vendas",      setVendas), // PDV (Caixa) — mesma fonte que o Financeiro soma ao faturamento
    ];
    return () => unsubs.forEach(u => u && u());
  }, []);

  return { pedidos, filamentos, impressoras, materiais, produtos, falhas, fila, orcamentos, vendas, loading };
}
